import { EventManager } from 'hanako-ts/dist-legacy/Tools/EventManager';
export class Swiper {
    constructor(element) {
        this.xDown = null;
        this.yDown = null;
        this.element = typeof (element) === 'string' ? document.querySelector(element) : element;
        this.element.on('touchstart', (event) => {
            this.xDown = event.touches[0].clientX;
            this.yDown = event.touches[0].clientY;
        });
        this.element.on('touchmove', (event) => {
            this.handleTouchMove(event);
        });
    }
    on(eventNames, callback) {
        if (typeof eventNames == 'string')
            eventNames = [eventNames];
        eventNames.forEach((eventName) => {
            EventManager.add(this.element.get(0), eventName, null, callback, false);
        });
    }
    handleTouchMove(event) {
        if (!this.xDown || !this.yDown)
            return;
        this.xDiff = this.xDown - event.touches[0].clientX;
        this.yDiff = this.yDown - event.touches[0].clientY;
        if (Math.abs(this.xDiff) < 100 && Math.abs(this.yDiff) < 100)
            return;
        if (Math.abs(this.xDiff) > Math.abs(this.yDiff)) {
            if (this.xDiff > 0) {
                this.trigger('swipeLeft');
            }
            else {
                this.trigger('swipeRight');
            }
        }
        else {
            if (this.yDiff > 0) {
                this.trigger('swipeUp');
            }
            else {
                this.trigger('swipeDown');
            }
        }
        this.xDown = null;
        this.yDown = null;
    }
    trigger(eventName) {
        const event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, true, false);
        this.element.get(0).dispatchEvent(event);
    }
}
